// extracted by mini-css-extract-plugin
export const title = "h_h";
export const description = "h_j";